import _jsx from "@babel/runtime/helpers/jsx";
import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { CloseButton, Button } from 'reaxl';
import ProfileContainer from '../ProfileContainer';
import HeaderBadgeMenuLinks from '../HeaderBadgeMenuLinks';
function HeaderBadgeSlidingMenu(_ref) {
  let {
    profile = {},
    isLoggedIn = false,
    navItems = [],
    isSlidingMenuOpen,
    handleSlidingMenuClose,
    onSignOutClick = () => {}
  } = _ref;
  const navRef = useRef(null);
  const onClick = () => {
    onSignOutClick();
    handleSlidingMenuClose();
  };
  useEffect(() => {
    if (isSlidingMenuOpen && navRef) {
      navRef.current.scrollTop = 0;
    }
  }, [isSlidingMenuOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    "aria-hidden": "true",
    "data-cmp": "slidingMenuOverlay",
    className: clsx(isSlidingMenuOpen && 'open', 'sliding-menu-overlay'),
    onClick: handleSlidingMenuClose
  }), /*#__PURE__*/_jsx("div", {
    "data-cmp": "slidingMenu",
    className: clsx(isSlidingMenuOpen && 'open', 'sliding-menu slide-from-right')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "sliding-menu-header"
  }, void 0, /*#__PURE__*/_jsx(CloseButton, {
    onClick: handleSlidingMenuClose
  })), /*#__PURE__*/React.createElement("nav", {
    "data-cmp": "headerBadgeMobileNav",
    className: " sliding-menu-container",
    ref: navRef
  }, profile && /*#__PURE__*/_jsx(ProfileContainer, {
    profile: profile
  }), /*#__PURE__*/_jsx("ul", {
    className: "sliding-menu-links"
  }, void 0, navItems.map(item => /*#__PURE__*/_jsx(HeaderBadgeMenuLinks, {
    navItem: item
  }, item.label))), isLoggedIn && /*#__PURE__*/_jsx(Button
  // for accessibility - ensure the sliding menu is closed when user tabs out of its contents
  , {
    onBlur: handleSlidingMenuClose,
    block: true,
    bsSize: "small",
    onClick: onClick
  }, void 0, "Sign Out"))));
}
export default HeaderBadgeSlidingMenu;